<template>
  <div class="flex flex-col flex-grow">
    <BlockModalContainer />
    <BlockHeader />
    <div class="flex-grow flex flex-col relative">
      <div
        v-if="!disableDefault"
        class="flex-grow flex flex-col max-w-screen-xl w-full mx-auto px-5"
        :class="[tight ? 'pt-4 lg:pt-8 pb-16 lg:pb-24' : 'py-16 lg:py-24']"
      >
        <slot />
      </div>

      <div
        class="bottom-0 right-0 p-10"
        :class="[isIntersecting ? 'absolute' : 'fixed']"
      >
        <slot name="buttonArea" />

        <CoreIcon
          @click="handleToTop"
          class="transition-opacity cursor-pointer mx-auto"
          :class="{ 'opacity-0 pointer-events-none': !scrolled }"
          :width="isMobile ? 16 : 25"
          :color="fgColor"
        >
          <IconUp />
        </CoreIcon>
      </div>
    </div>
    <BlockFooter />
  </div>
</template>

<script>
import throttle from "lodash.throttle";
import { bind, unbind } from "@utils/eventListener";
import { mapState } from "vuex";
import BlockHeader from "./BlockHeader";
import BlockFooter from "./BlockFooter";
import BlockModalContainer from "./BlockModalContainer";
import { IconUp } from "@c/Icon";

export default {
  name: "BlockContainer",

  components: {
    IconUp,
    BlockHeader,
    BlockFooter,
    BlockModalContainer
  },

  props: {
    tight: {
      type: Boolean,
      default: false
    },
    disableDefault: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    scrolled: false,
    isIntersecting: true
  }),

  computed: {
    ...mapState({
      fgColor: state => state.ui.fgColor,
      isMobile: state => state.ui.isMobile
    })
  },

  mounted() {
    this.throttledScrollHandler = throttle(this.scrollHandler, 150);
    bind(window, "scroll", this.throttledScrollHandler);

    this.observer = new IntersectionObserver(this.handleIntersection);
    this.observer.observe(document.querySelector("footer"));
  },

  beforeDestroy() {
    unbind(window, "scroll", this.throttledScrollHandler);
    this.observer.disconnect();
  },

  methods: {
    handleIntersection(entries) {
      this.isIntersecting = entries[0].isIntersecting;
    },
    scrollHandler() {
      this.scrolled = document.documentElement.scrollTop > 0;
    },
    handleToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
